import { ConfigType, ParentType } from './SoundManager.interface';

export class Sound {
	sound: number | null = null;
	config: ConfigType;
	soundInstance: ParentType;
	cVolume = 1;
	destroyed = false;
	unique_name = '';
	timeOut = null;
	onCompleted = (_sound: Sound) => {};

	constructor(
		config: ConfigType,
		soundInstance: ParentType,
		onCompleted: (sound: Sound) => void
	) {
		this.soundInstance = soundInstance;
		this.config = config;
		this.onCompleted = onCompleted;
	}

	play(config: ConfigType) {
		this.config = config;
		this.cVolume = config.volume || this.cVolume;

		try {
			this.sound = this.soundInstance.play(config.name);
			this.unique_name = config.name + '_' + this.sound;
			if (config.loop) {
				this.soundInstance.loop(true, this.sound);
			}

			// if (obj.fadeOut > 0) {
			//   // this.timeOut = setTimeout(() => {
			//   //   this.parent.GlobalSound.fade(this.cvolume, 0, obj.fadeOut, this.sound);
			//   //   setTimeout(() => {
			//   //     this.parent.GlobalSound.fade(this.cvolume, this.cvolume, obj.fadeOut, this.sound);
			//   //   }, obj.fadeOut);
			//   //   // clearTimeout(this.timeOut);
			//   // }, this.parent.GlobalSound.duration(this.sound) * 1000 - obj.fadeOut);
			// }
			if (config.fade) {
				this.soundInstance.fade(0, this.cVolume, config.fade, this.sound);
			} else {
				if (config.muted) {
					this.soundInstance.volume(0, this.sound);
				} else {
					this.soundInstance.volume(this.cVolume, this.sound);
				}
			}

			this.soundInstance.once(
				'play',
				(soundID) => {
					if (soundID !== this.sound) {
						return;
					}
					if (this.destroyed) {
						this.soundInstance.stop(this.sound);
					}
				},
				this.sound
			);

			this.soundInstance.once(
				'end',
				(soundID) => {
					if (soundID !== this.sound) {
						return;
					}
					if (config.loop) {
						return;
					}
					this.soundInstance.stop(this.sound);
					this.onCompleted(this);
				},
				this.sound
			);
		} catch (error) {
			console.dir(error);
		}
		return this.sound;
	}

	stop(fade: number) {
		// if (this.timeOut) {
		//   clearTimeout(this.timeOut);
		// }

		if (fade === 0) {
			this.destroy();
			this.onCompleted(this);
		} else {
			this.volume(0, fade);
			setTimeout(() => {
				this.destroy();
				this.onCompleted(this);
			}, fade + 50);
		}
	}

	destroy() {
		if (this.timeOut) {
			clearTimeout(this.timeOut);
		}
		this.destroyed = true;
		try {
			if (this.sound) {
				this.soundInstance.stop(this.sound);
			}
		} catch (error) {
			console.error(error);
		}
	}

	volume(vol: number, fade: number) {
		if (this.timeOut) {
			clearTimeout(this.timeOut);
		}
		if (vol === undefined) {
			return this.soundInstance.volume(this.sound!);
		}

		const cVol = this.soundInstance.volume(this.sound!) as number;
		vol = vol * this.cVolume;

		if (fade > 0) {
			this.soundInstance.fade(cVol, vol, fade, this.sound!);
		} else {
			this.soundInstance.volume(vol, this.sound!);
		}
	}
}
